import { AlertDialog } from "@repo/ui/components/Base/AlertDialog";

export interface ErrorsDialogProps {
  title?: string;
  errors: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ErrorsDialog = ({
  title,
  errors,
  open,
  setOpen,
}: ErrorsDialogProps) => {
  return (
    <AlertDialog
      title={title ?? "Errors Occurred"}
      message={
        <p>
          {errors
            .split("\n")
            .reduce(
              (jsx, line, i) => (jsx.push(line, <br key={i} />), jsx),
              [] as React.ReactNode[]
            )
            .slice(0, -1)}
        </p>
      }
      open={open}
      setOpen={setOpen}
    />
  );
};
